// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__19vuO","title":"BackImages_title__3V3cV","images":"BackImages_images__SXuLS"};